import styled from 'styled-components';
export const SuggestionsWrapper = styled.div `
  padding-top: 20px;
`;
//# sourceMappingURL=Suggestions.styled.js.map